import styled from 'styled-components';
import Button from '~/components/form-elements/button';
import { color, media, spacing } from '~/theme';
import typography, { rem } from '~/theme/variables/typography';

export const HeaderContainer = styled.header`
    position: relative;
    background-color: ${color.palette.black};
`;

export const HeaderInnerContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    max-width: 22.625rem;
    height: ${rem(50)};
    margin: ${spacing.spacing0} auto;
    padding-left: ${spacing.spacing4};
    padding-right: ${spacing.spacing4};
    color: ${color.palette.white};

    @media (${media.small}) {
        max-width: 48rem;
    }

    @media (${media.medium}) {
        max-width: 72rem;
    }

    svg {
        width: ${spacing.spacing6};
        height: ${spacing.spacing6};
        margin-bottom: ${spacing.spacing0};
    }
`;

export const HeaderRightContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: calc(${spacing.spacing4} + ${spacing.spacing1});
`;

export const HeaderLogoContainer = styled.div`
    a {
        display: inline-block;
    }
`;

export const LanguageToggleContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
`;

export const HeaderButton = styled(Button).attrs({ appearance: 'dark' })<{}>`
    border: none;
    min-width: auto;
    width: auto;
    padding: calc(${spacing.spacing3} - 2px) ${spacing.spacing3};
    font-size: ${rem(typography.defaultFontSize)};
    margin: ${spacing.spacing0};
`;

export default {
    HeaderContainer,
    HeaderLogoContainer,
    LanguageToggleContainer,
    HeaderButton,
};
